module.exports = __webpack_public_path__ + "static/media/31JFA2.424ba7eb.jpg";